/**
 * 按是否融合系统决定默认主题：
 * - 融合调度 isFusion=true → 蓝色
 * - 非融合 isFusion=false → 白色（与登录页背景逻辑一致）
 * - 尚未拿到系统类型时保持蓝色，避免融合环境首屏闪白
 */
export function getDefaultTheme(isFusion) {
  let fusion = isFusion
  if (fusion === undefined || fusion === null) {
    const v = localStorage.getItem('isFusion')
    if (v === null || v === undefined || v === '') {
      return 'blue'
    }
    fusion = v === '1' || v === 'true'
  }
  return fusion ? 'blue' : 'white'
}

/**
 * 应用系统主题样式。
 * 分屏窗口走 /xxx_split_screen 等上一级路由，不挂载 Main，需自行调用本方法，
 * 否则 :root[theme] 与 body 主题 class 不会生效。
 */
export function applyTheme(themeName) {
  const theme = themeName || localStorage.getItem('theme') || localStorage.getItem('className') || getDefaultTheme()
  const root = document.documentElement

  switch (theme) {
    case 'black':
      root.style.removeProperty('--backgroud-color')
      root.style.removeProperty('--backgroud-img')
      root.style.removeProperty('--scroll-color')
      root.style.removeProperty('--thumb-color')
      root.style.removeProperty('--primary-color')
      root.style.removeProperty('--button-little-color')
      root.style.removeProperty('--search-font')
      root.style.removeProperty('--middle-div-color')
      root.style.removeProperty('--body-color')
      break
    case 'blue':
      root.style.setProperty('--backgroud-color', 'unset')
      root.style.setProperty('--backgroud-img', 'url("../../assets/images/new-back.png") !important')
      root.style.setProperty('--scroll-color', 'rgb(16,36,47)')
      root.style.setProperty('--thumb-color', '#00d5ff')
      root.style.setProperty('--primary-color', '#00d5ff')
      root.style.setProperty('--button-little-color', '#00d4ff')
      root.style.setProperty('--search-font', '#03B3D6')
      root.style.setProperty('--middle-div-color', 'rgba(22, 47, 61, 0.45)')
      // 清掉白主题写在 :root 上的内联变量，避免切蓝后残留白底/字色
      root.style.removeProperty('--body-color')
      break
    case 'white':
      // 其它页面白底；主控台灰蓝底由 .main-console-page 单独控制
      root.style.setProperty('--scroll-color', '#f5f7fa')
      root.style.setProperty('--thumb-color', '#909399')
      root.style.setProperty('--primary-color', '#1890ff')
      root.style.setProperty('--button-little-color', '#1890ff')
      root.style.setProperty('--backgroud-color', '#ffffff')
      root.style.setProperty('--search-font', '#333333')
      root.style.setProperty('--middle-div-color', 'transparent')
      root.style.setProperty('--body-color', '#ffffff')
      break
    default:
      root.style.setProperty('--scroll-color', 'whitesmoke')
      root.style.setProperty('--thumb-color', 'dimgrey')
      root.style.setProperty('--primary-color', '#353535')
      break
  }

  const className = ['black', 'blue', 'white'].indexOf(theme) >= 0 ? theme : getDefaultTheme()
  localStorage.setItem('className', className)
  localStorage.setItem('theme', className)
  root.setAttribute('theme', className)
  // body 可能尚未就绪（极早调用时）；属性已写在 html 上，样式即可匹配
  if (document.body) {
    document.body.classList.remove('black', 'blue', 'white')
    document.body.classList.add(className)
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      document.body.classList.remove('black', 'blue', 'white')
      document.body.classList.add(className)
    })
  }
  return className
}



// WEBPACK FOOTER //
// ./src/libs/theme.js